export default [
  {
    path: '/serverdinstitutionsearch', // 就医记录查询
    name: 'serverdinstitutionsearch',
    component: () => {
      return import(
        /* webpackChunkName: "medicalrecords" */ '@/views/medicalrecords/serverdinstitutionsearch.vue'
      )
    }
  },
  {
    path: '/medicalevaluation', // 就医体验
    name: 'medicalevaluation',
    component: () => {
      return import(
        /* webpackChunkName: "medicalrecords" */ '@/views/medicalrecords/medicalevaluation.vue'
      )
    }
  },
  {
    path: '/consultationSummary', // 就医体验
    name: 'consultationSummary',
    component: () => {
      return import(
        /* webpackChunkName: "medicalrecords" */ '@/views/medicalrecords/consultationSummary.vue'
      )
    }
  }
]
